module.exports = __webpack_public_path__ + "img/preview-3.32291700.webp";